export const PrimengPreset = {
  components: {
    dialog: { borderRadius: '0.375rem' },
    checkbox: { borderRadius: '0.375rem' },
    inputtext: { paddingY: '.75rem', paddingX: '.75rem' },
    inputtextarea: { paddingY: '.75rem', paddingX: '.75rem' },
  },
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{blue.500}',
          inverseColor: '#ffffff',
          hoverColor: '{blue.400}',
          activeColor: '{blue.300}',
        },
      },
    },
  },
};
